import { LegalLayout } from "./LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout
      eyebrow="Rechtliches"
      title={<>Impressum</>}
      updated="12. Mai 2026"
    >
      <p>Angaben gemäß § 5 TMG:</p>

      <h2>Anbieter</h2>
      <p>
        <strong>tino24/7 GmbH</strong>
        <br />
        Ringbahnstr. 42
        <br />
        12099 Berlin
        <br />
        Deutschland
      </p>

      <h2>Vertretungsberechtigte Geschäftsführung</h2>
      <p>Kai Först</p>

      <h2>Handelsregister</h2>
      <p>
        Eingetragen im Handelsregister des Amtsgerichts Berlin
        Charlottenburg
        <br />
        Registernummer: HRB 256376 B
      </p>

      <h2>Steuerliche Angaben</h2>
      <p>
        Steuernummer: 20 298 51421
        <br />
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
        DE365576955
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon:{" "}
        <a href="tel:+4915792316531">+49 1579 2316531</a>
        <br />
        Erzähler-Telefon (nur nach Registrierung):{" "}
        <a href="tel:+4941037044937">+49 4103 7044937</a>
        <br />
        E-Mail:{" "}
        <a href="mailto:kontakt@tino247.de">kontakt@tino247.de</a>
      </p>

      <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
      <p>
        Kai Först
        <br />
        tino24/7 GmbH
        <br />
        Ringbahnstr. 42
        <br />
        12099 Berlin
      </p>

      <h2>Streitbeilegung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
        . Unsere E-Mail-Adresse finden Sie oben im Impressum.
      </p>
      <p>
        Wir sind <strong>nicht bereit oder verpflichtet</strong>, an
        Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>

      <h2>Haftungsausschluss</h2>
      <p>
        Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt.
        Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
        können wir jedoch keine Gewähr übernehmen.
      </p>
    </LegalLayout>
  );
}
